module.exports = __webpack_public_path__ + "media/icons/pencil-d86e74ff.png";